/* LT holiday helpers reused from task17-calendar-core/task16-calendar-utils (event order-by planning). */
const iso = (y,m,d)=>`${y}-${String(m).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
const shift = (iso,n)=>new Date(Date.parse(iso+'T12:00:00Z')+n*86400000).toISOString().slice(0,10);
const easter = function easter(y){const a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451);return `${y}-${String(Math.floor((h+l-7*m+114)/31)).padStart(2,'0')}-${String((h+l-7*m+114)%31+1).padStart(2,'0')}`;};
const nthWeekday = function nthWeekday(y,m,weekday,n){const first=iso(y,m,1),delta=(weekday-new Date(first+'T12:00:00Z').getUTCDay()+7)%7;if(n==='last'){const last=new Date(Date.UTC(y,m,0,12)).toISOString().slice(0,10);return shift(last,-((new Date(last+'T12:00:00Z').getUTCDay()-weekday+7)%7));}const result=shift(first,delta+(n-1)*7);if(Number(result.slice(5,7))!==m)throw Error('Weekday outside month');return result;};
const ltHolidays = function ltHolidays(y){return new Set(['01-01','02-16','03-11','05-01','06-24','07-06','08-15','11-01','11-02','12-24','12-25','12-26'].map(md=>`${y}-${md}`).concat([easter(y),shift(easter(y),1),nthWeekday(y,5,0,1),nthWeekday(y,6,0,1)]));};
export function addWorkingDays(date, count) {
  let current = date;
  let holidayYear, holidays;
  while (count > 0) {
    current = shift(current, 1);
    const year = Number(current.slice(0, 4));
    if (year !== holidayYear) { holidayYear = year; holidays = ltHolidays(year); }
    const weekday = new Date(current + 'T12:00:00Z').getUTCDay();
    if (weekday !== 0 && weekday !== 6 && !holidays.has(current)) count--;
  }
  return current;
}
export function vilniusDate(now = new Date()) {
  return new Intl.DateTimeFormat('sv-SE', {timeZone: 'Europe/Vilnius'}).format(now);
}
export function deliveryRange(date) {
  return [addWorkingDays(date, 7), addWorkingDays(date, 20)];
}
export function formatRange(range, months) {
  const [start, end] = range;
  const format = date => months[Number(date.slice(5, 7)) - 1] + ' ' + Number(date.slice(8, 10));
  return [format(start), start.slice(0, 7) === end.slice(0, 7) ? String(Number(end.slice(8, 10))) : format(end)];
}
if (typeof document !== 'undefined') {
  let lastDate;
  const update = () => {
    const date = vilniusDate();
    if (date === lastDate) return;
    lastDate = date;
    for (const line of document.querySelectorAll('[data-delivery-estimate]')) {
      const months = line.dataset.months.split(',');
      const [start, end] = formatRange(deliveryRange(date), months);
      line.textContent = line.dataset.template.replace('[start]', start).replace('[end]', end);
      line.hidden = false;
    }
  };
  update();
  setInterval(update, 60000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
}
